import { KompisCopyDesignCode } from '@inter-ikea-kompis/react-components';
import { getVpcCode } from 'ducks/vpc';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CopyDesignCodeStateEnum } from '@inter-ikea-kompis/component-copy-design-code';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useServiceSettings } from 'contexts/serviceSettings';

const CopyDesignCodeWrapper = styled.div`
  margin: ${({ theme }) => theme.space.md} 0;
`;

type Props = {
  copyDesignCodeState: CopyDesignCodeStateEnum;
  setCopyDesignCodeState: React.Dispatch<React.SetStateAction<CopyDesignCodeStateEnum>>;
};

export const CopyDesignCode = ({ copyDesignCodeState, setCopyDesignCodeState }: Props) => {
  const vpcCode = useSelector(getVpcCode);
  const { translations } = useServiceSettings();

  return (
    <>
      {vpcCode && (
        <CopyDesignCodeWrapper>
          <KompisCopyDesignCode
            state={copyDesignCodeState}
            onCopy={() => setCopyDesignCodeState(CopyDesignCodeStateEnum.success)}
            onReset={() => setCopyDesignCodeState(CopyDesignCodeStateEnum.default)}
            vpcCode={vpcCode}
            theme={SkapaTheme}
            translations={translations.kompis}
          />
        </CopyDesignCodeWrapper>
      )}
    </>
  );
};
